<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" [style.transform]="'scale(' + scale + ')'">
  <g transform="translate(-.234 -289.296)" fill="none" stroke="currentColor">
    <circle r="9.542" cy="301.627" cx="12.648" stroke-width="1.953" stroke-linejoin="round" />
    <path d="M19.274 308.589l8.054 7.885" stroke-width="2" stroke-linecap="round" />
  </g>
</svg>
